export default {
    state: {
        url: '/api/hms/compliances/complaints',
        complaints: [],
        complaint: [],
        complaint_id: null,
        auth_user: localStorage.getItem('user_info') != null ? JSON.parse(localStorage.getItem('user_info')) : null,
        errors: {},
        form: {
            date: null,
            facility_id: '',
            unit_id: '',
            complained_by: '',
            client_id: '',
            inspector_id: '',
            hasa_name: '',
            other_name: '',
            description: '',
            notes: ''
        },
        respond_form: {},
        review_form: {},
        resident_form: {},
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'date', label: 'Date', sortable: true, tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'unit', label: 'Unit', tdClass: 'text-muted'},
                {key: 'complaint_by', label: 'Complaint by', tdClass: 'text-muted'},
                {key: 'created_by', label: 'Created By', tdClass: 'text-muted'},
                {key: 'status', label: 'Status', sortable: true, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'res_to_hasa', label: 'Response to HASA', sortable: true, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        }
    },

    getters: {
        getComplaintTableFields: state => state.table.fields,

        getComplaintForm: state => state.form,

        getComplaintRespondForm: state => state.respond_form,

        getComplaintReviewForm: state => state.review_form,

        getComplaintResidentForm: state => state.resident_form,

        getComplaintsMeta: state => state.meta,

        getComplaintErrors: state => state.errors,

        getComplaint: state => state.complaint,
    },

    mutations: {
        setComplaints: (state, payload) => {
            state.complaints = payload;
        },

        setComplaint: (state, payload) => {
            state.complaint_id = payload.complaint_id;
            state.complaint = payload;
        },

        setComplaintsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setComplaintForm: state => {
            state.form = {
                date: null,
                facility_id: '',
                unit_id: '',
                complained_by: '',
                client_id: '',
                inspector_id: '',
                hasa_name: '',
                other_name: '',
                description: '',
                notes: ''
            };

            state.errors = {};
        },

        setComplaintRespondForm: state => {
            state.respond_form = {
                complaint_id: state.complaint.complaint_id,
                assigned_id: '',
                date: null,
                outcome: '',
                work_completed: ''
            };

            state.errors = {};
        },

        setComplaintReviewForm: state => {
            state.review_form = {
                complaint_id: state.complaint.complaint_id,
                reviewed_by: state.auth_user.attributes.user_id,
                date: null,
                hasa_respond_date: null,
            };

            state.errors = {};
        },

        setComplaintResidentForm: state => {
            state.resident_form = {
                complaint_id: state.complaint.complaint_id,
                date: null,
                findings: '',
                action_taken: '',
                copy: '',
            };

            state.errors = {};
        },

        setComplaintErrors: (state, payload) => {
            state.errors = payload;
        },

        resetComplaintsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },
    },

    actions: {
        fetchComplaints: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url, {params: parameters})
                    .then(response => {
                        commit('setComplaints', response.data);

                        commit('setComplaintsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setComplaintErrors', error.response.data.errors);

                        reject(error);
                    });
            });
        },

        submitComplaint: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setComplaintErrors', error.response.data.errors);

                        reject(error);
                    });
            })
        },

        fetchComplaint: ({state, commit}, complaint_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + complaint_id)
                    .then(response => {
                        commit('setComplaint', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitComplaintRespond: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.complaint.complaint_id + '/respond', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setComplaintErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitComplaintReview: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.complaint.complaint_id + '/review', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setComplaintErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitComplaintResident: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.complaint.complaint_id + '/resident', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setComplaintErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },
    }
}
